import React, { FC, useCallback, useMemo, useState } from 'react';
import { Box } from '@src/atoms/Box';
import { Unit } from '@src/core/Unit';
import { ISidebarMenuProps } from './models';
import { classnames } from '@src/utils/classnames';
import { SidebarMenuItem } from './_Item/SidebarMenuItem';
import { BASE_UNIT_ID } from './const';
import { Fixable } from '@src/atoms/Fixable';
import { Input } from '@src/atoms/Input';

import { getClasses } from '@src/utils/getClass';
import styles from './SidebarMenu@desktop.scss';
import { filterMenuItems } from '@src/molecules/SidebarMenu/utils';

export const SidebarMenuDesktop: FC<ISidebarMenuProps> = ({
  className,
  style,
  items,
  itemClasses,
  containerId,
  duration,
  fixedPosition,
  isScroll,
  offset,
  onFixed,
  parentRef,
  position,
  smooth,
  itemOffset,
  theme = 'dark',
  isItemTooltip,
  isNestedOpened = false,
  withSearch = false,
  basePath,
  currentPathname,
  preSearch,
  afterSearch,
  rounded,
  noOfLines = 1,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const classNames = classnames(styles.root, className, ...getClasses(styles, { theme }));
  const filteredItems = useMemo(() => filterMenuItems(items, searchValue), [searchValue, items]);
  const handleChangeSearch = useCallback((event) => {
    setSearchValue(event.target.value);
  }, []);

  return (
    <Fixable
      fixedPosition={fixedPosition}
      isScroll={isScroll}
      offset={offset}
      parentRef={parentRef}
      position={position}
      onFixed={onFixed}
    >
      <Unit id={BASE_UNIT_ID}>
        <Box column className={classNames} style={style}>
          {withSearch && (
            <Box fullWidth paddingLeft={24} paddingBottom={16} gap={8} alignItems="center" data-elem="side-bar-search">
              {preSearch && preSearch}
              <Input
                id="SidebarMenuSearchInput"
                preIcon="search"
                placeholder="Поиск по названию"
                value={searchValue}
                onChange={handleChangeSearch}
                showResetButton
              />
              {afterSearch && afterSearch}
            </Box>
          )}
          {filteredItems.map((item) => (
            <SidebarMenuItem
              key={item.id}
              {...item}
              theme={theme}
              className={itemClasses}
              containerId={containerId}
              duration={duration}
              smooth={smooth}
              offset={itemOffset}
              isItemTooltip={isItemTooltip}
              isNestedOpened={isNestedOpened}
              basePath={basePath}
              currentPathname={currentPathname}
              withSearch={withSearch}
              rounded={rounded}
              noOfLines={noOfLines}
            />
          ))}
        </Box>
      </Unit>
    </Fixable>
  );
};
